// heon-m conversion and personalization tests: written by heon-m into the theme, never edited by hand.
// Splits visitors in two for good with a cookie, shows the variant block to the second half on the pages each block belongs to,
// and reports the steps of the visitors who could have seen it once the store's privacy settings allow analytics.
// What a personalization block shows (pieces viewed, the ad's product) stays in this browser and only where preferences are allowed.
(function () {
    var configNode = document.getElementById("heonm-ab-config");
    if (!configNode) return;
    var config = JSON.parse(configNode.textContent);
    var template = configNode.getAttribute("data-template") || "";
    var locale = configNode.getAttribute("data-locale") || "";
    var productId = configNode.getAttribute("data-product-id") || "";
    var productHandle = configNode.getAttribute("data-product-handle") || "";
    var country = configNode.getAttribute("data-country") || "";
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var BOT_PATTERN = /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|preview|monitor/i;
    var isBot = navigator.webdriver === true || BOT_PATTERN.test(navigator.userAgent);
    var YEAR_SECONDS = 31536000;
    var VIEWED_KEEP_COUNT = 8;
    var VIEWED_SHOW_COUNT = 4;

    function readCookie(name) {
        var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
        return match ? decodeURIComponent(match[1]) : null;
    }
    function writeCookie(name, value) {
        document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; max-age=" + YEAR_SECONDS + "; SameSite=Lax";
    }
    function randomId() {
        var bytes = new Uint8Array(12);
        crypto.getRandomValues(bytes);
        return Array.prototype.map.call(bytes, function (b) { return ("0" + b.toString(16)).slice(-2); }).join("");
    }
    function isAllowed(method) {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (privacy && typeof privacy[method] === "function") return privacy[method]() === true;
        return true;
    }
    function canMeasure() { return isAllowed("analyticsProcessingAllowed"); }
    function canPersonalize() { return isAllowed("preferencesProcessingAllowed"); }
    function readStore(storage, key) {
        try { return JSON.parse(storage.getItem(key) || "null"); } catch (e) { return null; }
    }
    function writeStore(storage, key, value) {
        try { storage.setItem(key, JSON.stringify(value)); } catch (e) {}
    }
    function hasType(type) {
        return config.tests.some(function (test) { return test.type === type; });
    }

    // The browser's own memory for the personalization blocks: earlier pieces, and the piece an ad brought the visitor to.
    // heon-m's own preview hands in the memory a visitor would have built, and measures nothing.
    var preview = config.preview || null;
    var viewed = [];
    var campaignHandle = null;
    if (preview) {
        viewed = (preview.viewed || []).filter(function (handle) { return handle !== productHandle; });
        campaignHandle = preview.campaign || null;
    } else if (canPersonalize()) {
        viewed = (readStore(localStorage, "heonm_rv") || []).filter(function (handle) { return typeof handle === "string" && handle !== productHandle; });
        if (template === "product" && productHandle && hasType("recently_viewed")) writeStore(localStorage, "heonm_rv", [productHandle].concat(viewed).slice(0, VIEWED_KEEP_COUNT));
        var params = new URLSearchParams(location.search);
        var isAdLanding = params.has("utm_campaign") || params.has("gclid") || params.has("fbclid") || params.has("msclkid");
        if (template === "product" && productHandle && isAdLanding && hasType("campaign_product")) writeStore(sessionStorage, "heonm_campaign", productHandle);
        campaignHandle = readStore(sessionStorage, "heonm_campaign");
    }
    var shownViewed = viewed.slice(0, VIEWED_SHOW_COUNT);

    // Who could see a block in either arm: its page in a language it was written in, and for a block the browser fills,
    // something to fill it with.
    function isEligible(test) {
        if ((test.templates || ["product"]).indexOf(template) < 0) return false;
        if ((test.locales || []).indexOf(locale) < 0) return false;
        if (test.type === "recently_viewed") return shownViewed.length > 0;
        if (test.type === "campaign_product") return typeof campaignHandle === "string";
        if (test.type === "complete_the_look") return productId !== "";
        return true;
    }

    var arms = {};
    (readCookie("heonm_ab") || "").split(",").forEach(function (pair) {
        var parts = pair.split(":");
        if (parts.length === 2 && (parts[1] === "a" || parts[1] === "b")) arms[parts[0]] = parts[1];
    });
    var visitorId = readCookie("heonm_vid");
    if (!visitorId) {
        visitorId = randomId();
        writeCookie("heonm_vid", visitorId);
    }
    var splitTests = config.tests.filter(function (test) { return test.mode === "split"; });
    splitTests.forEach(function (test) {
        if (!arms[test.key]) arms[test.key] = Math.random() < 0.5 ? "a" : "b";
    });
    writeCookie("heonm_ab", Object.keys(arms).filter(function (key) {
        return splitTests.some(function (test) { return test.key === key; });
    }).map(function (key) { return key + ":" + arms[key]; }).join(","));

    function findBuyForm() {
        var forms = Array.prototype.slice.call(document.querySelectorAll('form[action$="/cart/add"]'));
        return forms.filter(function (form) { return !/quick/i.test(form.id || ""); })[0] || forms[0] || null;
    }
    // Where each block type stands and in which order beside the others of its place.
    var ORDER = ["delivery_estimate", "size_guide", "reviews_near_button", "trust_info", "market_banner", "campaign_product", "recently_viewed", "complete_the_look"];
    var CARD_COUNTS = { recently_viewed: 4, complete_the_look: 2 };
    var DAY_MS = 86400000;
    function placeInOrder(container, element, type) {
        element.setAttribute("data-heonm-order", String(ORDER.indexOf(type)));
        var later = Array.prototype.filter.call(container.children, function (child) {
            return Number(child.getAttribute("data-heonm-order")) > ORDER.indexOf(type);
        })[0] || null;
        container.insertBefore(element, later);
    }
    // The product column's blocks share one stack right after the Add to cart block, above the theme's assurance list.
    function findStack(form) {
        var existing = document.querySelector(".heonm-yigin");
        if (existing) return existing;
        var buyBlock = form.closest(".product-info__block") || form;
        var holder = document.createElement("div");
        holder.className = "product-info__block";
        var stack = document.createElement("div");
        stack.className = "heonm-yigin";
        holder.appendChild(stack);
        buyBlock.parentNode.insertBefore(holder, buyBlock.nextSibling);
        return stack;
    }
    function findAfterSection(form) {
        var existing = document.querySelector("[data-heonm-after]");
        if (existing) return existing;
        var section = form.closest(".shopify-section") || form;
        var holder = document.createElement("div");
        holder.setAttribute("data-heonm-after", "");
        section.parentNode.insertBefore(holder, section.nextSibling);
        return holder;
    }
    function insertBlock(test, element) {
        element.setAttribute("data-heonm-shown", test.key);
        if (test.type === "market_banner" || test.type === "campaign_product") {
            var main = document.querySelector("main") || document.body;
            var top = main.querySelector(":scope > [data-heonm-top]");
            if (!top) {
                top = document.createElement("div");
                top.setAttribute("data-heonm-top", "");
                main.insertBefore(top, main.firstChild);
            }
            placeInOrder(top, element, test.type);
            return;
        }
        var form = findBuyForm();
        if (!form) return;
        placeInOrder(test.type === "recently_viewed" || test.type === "complete_the_look" ? findAfterSection(form) : findStack(form), element, test.type);
    }
    function fetchJson(url) {
        return fetch(url, { credentials: "same-origin" }).then(function (response) { return response.ok ? response.json() : null; }).catch(function () { return null; });
    }
    function fetchProduct(handle) {
        return fetchJson(root + "products/" + encodeURIComponent(handle) + ".js");
    }
    function readRecommendations(intent) {
        return fetchJson(root + "recommendations/products.json?product_id=" + encodeURIComponent(productId) + "&limit=4&intent=" + intent).then(function (answer) { return (answer && answer.products) || []; });
    }
    function readProducts(test) {
        if (test.type === "recently_viewed") return Promise.all(shownViewed.map(fetchProduct));
        if (test.type === "campaign_product") return fetchProduct(campaignHandle).then(function (product) { return [product]; });
        return readRecommendations("complementary").then(function (products) { return products.length > 0 ? products : readRecommendations("related"); });
    }
    function imageOf(product) {
        var image = typeof product.featured_image === "string" ? product.featured_image : product.featured_image && product.featured_image.src;
        return image || "";
    }
    function element(tag, className, text) {
        var node = document.createElement(tag);
        if (className) node.className = className;
        if (text) node.textContent = text;
        return node;
    }
    // The theme's own product card: the name before the first comma as its title, the rest as its subtitle.
    function buildCard(product) {
        var parts = String(product.title || "").split(",");
        var item = document.createElement("li");
        var card = element("product-card", "card card--standard heonm-kart");
        var media = element("a", "card__media heonm-kart__medya");
        media.href = product.url;
        var img = element("img", "img-fit");
        img.src = imageOf(product);
        img.alt = product.title;
        img.loading = "lazy";
        media.appendChild(img);
        var content = element("div", "card__content");
        var title = element("p", "card__title");
        var link = element("a", "card-link");
        link.href = product.url;
        link.appendChild(element("span", "hh-cn", parts[0].trim()));
        title.appendChild(link);
        content.appendChild(title);
        if (parts.length > 1) content.appendChild(element("span", "hh-cs", parts.slice(1).join(",").trim()));
        if (product.type) {
            var meta = element("div", "hh-cm");
            meta.appendChild(element("div", "hh-cm-metal", product.type));
            content.appendChild(meta);
        }
        var info = element("div", "card__info");
        info.appendChild(content);
        card.appendChild(media);
        card.appendChild(info);
        item.appendChild(card);
        return item;
    }
    function fillCampaign(block, product) {
        Array.prototype.forEach.call(block.querySelectorAll("[data-heonm-product-link]"), function (link) { link.href = product.url; });
        var img = block.querySelector(".heonm-kampanya__medya img");
        if (img) {
            img.src = imageOf(product);
            img.alt = product.title;
        }
        var title = block.querySelector("[data-heonm-product-title]");
        if (title) title.textContent = String(product.title || "").split(",")[0].trim();
    }
    // Business days from today, weekends skipped, the visitor's own language naming the date.
    function addBusinessDays(days) {
        var date = new Date();
        while (days > 0) {
            date = new Date(date.getTime() + DAY_MS);
            if (date.getDay() !== 0 && date.getDay() !== 6) days--;
        }
        return date;
    }
    function formatDate(date, options) {
        try { return date.toLocaleDateString(locale || undefined, options); } catch (e) { return date.toDateString(); }
    }
    function formatRange(from, to) {
        if (from.getMonth() === to.getMonth()) return formatDate(from, { month: "short", day: "numeric" }) + "–" + formatDate(to, { day: "numeric" });
        return formatDate(from, { month: "short", day: "numeric" }) + " – " + formatDate(to, { month: "short", day: "numeric" });
    }
    // The arrival line shows only where a transit time is set for the visitor's market; the first line left takes the heading.
    function fillDelivery(block) {
        var transit = (config.transit || {})[country] || null;
        var shipDays = 0;
        Array.prototype.forEach.call(block.querySelectorAll("[data-heonm-line]"), function (line) {
            line.textContent = line.textContent.replace(/\{ship:(\d+)\}/g, function (whole, days) {
                shipDays = Number(days);
                return formatDate(addBusinessDays(shipDays), { weekday: "short", month: "short", day: "numeric" });
            });
        });
        Array.prototype.forEach.call(block.querySelectorAll("[data-heonm-line]"), function (line) {
            var role = line.getAttribute("data-heonm-line");
            if (role === "arrive" && transit) line.textContent = line.textContent.replace(/\{arrive\}/g, formatRange(addBusinessDays(shipDays + transit[0]), addBusinessDays(shipDays + transit[1])));
            if ((role === "arrive" && !transit) || (role === "note" && transit)) line.parentNode.removeChild(line);
        });
        Array.prototype.forEach.call(block.querySelectorAll("[data-heonm-line]"), function (line, index) {
            line.className = index === 0 ? "hpb__h" : "hpb__note";
        });
    }
    // The page's own rating line, copied into the theme's rating row; a page without one shows the quote alone.
    function fillRating(block) {
        var row = block.querySelector(".heonm-puan");
        var source = document.querySelector(".hs-line .hs-row");
        var average = document.querySelector(".hs-line .hs-avg");
        var count = document.querySelector(".hs-line .hs-count");
        if (!row || !source || !average) return;
        var stars = row.querySelector(".hs-row");
        stars.setAttribute("style", source.getAttribute("style") || "");
        stars.setAttribute("aria-label", average.textContent.trim() + " out of 5 stars");
        row.querySelector(".hh-cr-n").textContent = average.textContent.trim();
        row.querySelector(".hh-cr-c").textContent = count ? count.textContent.trim() : "";
        row.hidden = false;
    }
    function showBlock(test) {
        var blockTemplate = document.querySelector('template[data-heonm-block="' + test.key + '"]');
        if (!blockTemplate || document.querySelector('[data-heonm-shown="' + test.key + '"]')) return;
        var block = blockTemplate.content.firstElementChild && blockTemplate.content.firstElementChild.cloneNode(true);
        if (!block) return;
        if (test.type === "delivery_estimate") fillDelivery(block);
        if (test.type === "reviews_near_button") fillRating(block);
        var list = block.querySelector(".heonm-oneri__liste");
        if (!list && test.type !== "campaign_product") {
            insertBlock(test, block);
            return;
        }
        readProducts(test).then(function (products) {
            var found = products.filter(function (product) { return product && product.url && product.handle !== productHandle; });
            if (found.length === 0 || document.querySelector('[data-heonm-shown="' + test.key + '"]')) return;
            if (list) found.slice(0, CARD_COUNTS[test.type] || 4).forEach(function (product) { list.appendChild(buildCard(product)); });
            else fillCampaign(block, found[0]);
            insertBlock(test, block);
        });
    }
    function render() {
        config.tests.forEach(function (test) {
            if (isEligible(test) && (test.mode === "all" || arms[test.key] === "b")) showBlock(test);
        });
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", render);
    else render();

    if (isBot || preview || splitTests.length === 0) return;
    // A visitor counts in a test from the page it could see the block on, and every later step of theirs counts there too.
    var exposedKeys = (canMeasure() && readStore(localStorage, "heonm_exp")) || [];
    var eligibleTests = splitTests.filter(isEligible);
    function listCounted() {
        return splitTests.filter(function (test) { return exposedKeys.indexOf(test.key) >= 0; });
    }
    function send(tests, event) {
        if (!canMeasure()) return;
        tests.forEach(function (test) {
            var body = new URLSearchParams({ testKey: test.key, arm: arms[test.key], event: event, visitorId: visitorId });
            if (!(navigator.sendBeacon && navigator.sendBeacon(config.endpoint, body))) {
                fetch(config.endpoint, { method: "POST", body: body, keepalive: true, mode: "no-cors" }).catch(function () {});
            }
        });
    }
    var isExposed = false;
    function expose() {
        if (isExposed || !canMeasure()) return;
        isExposed = true;
        send(eligibleTests, "exposure");
        eligibleTests.forEach(function (test) {
            if (exposedKeys.indexOf(test.key) < 0) exposedKeys.push(test.key);
        });
        writeStore(localStorage, "heonm_exp", exposedKeys.filter(function (key) {
            return splitTests.some(function (test) { return test.key === key; });
        }));
    }
    ["scroll", "pointerdown", "keydown", "touchstart"].forEach(function (name) {
        window.addEventListener(name, expose, { once: true, passive: true, capture: true });
    });
    function tagCart() {
        var value = listCounted().map(function (test) { return test.key + ":" + arms[test.key]; }).join(",");
        if (value === "") return;
        var attributes = {};
        attributes[config.cartAttributeKey] = value;
        fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: attributes }) }).catch(function () {});
    }
    var isAdded = false;
    function added() {
        expose();
        send(listCounted(), "add_to_cart");
        if (!isAdded) {
            isAdded = true;
            setTimeout(tagCart, 1500);
        }
    }
    document.addEventListener("submit", function (event) {
        var action = (event.target && event.target.getAttribute("action")) || "";
        if (/\/cart\/add/.test(action)) added();
        if (/\/cart\/?$/.test(action) || /\/checkout/.test(action)) send(listCounted(), "begin_checkout");
    }, true);
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var answer = nativeFetch.apply(this, arguments);
        if (/\/cart\/add/.test(url)) answer.then(function (response) { if (response.ok) added(); }).catch(function () {});
        return answer;
    };
    document.addEventListener("click", function (event) {
        var target = event.target && event.target.closest ? event.target.closest('[name="checkout"], a[href*="/checkout"], button[onclick*="checkout"]') : null;
        if (target) send(listCounted(), "begin_checkout");
    }, true);
})();
